module.exports = __webpack_public_path__ + "static/media/moemoecompany.905ea81b.png";